module.exports = __webpack_public_path__ + "img/8_16.51d06db9.png";